import SentimentRating from './SentimentRating';
export type { SentimentRatingProps } from './SentimentRating.types';
export default SentimentRating;
